<!--
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
-->
<template>
  <NotificationGroup
      group="bottom"
  >
    <div class="fixed inset-x-0 bottom-0 flex items-start justify-end p-6 px-4 py-6 pointer-events-none">
      <div class="w-full max-w-sm">
        <Notification
            v-slot="{ notifications }"
            enter="ease-out duration-300 transition"
            enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
            enter-to="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-500"
            leave-from="opacity-100"
            leave-to="opacity-0"
            move="transition duration-500"
            move-delay="delay-300"
        >
          <div
              v-for="notification in notifications"
              :key="notification.id"
              class="flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white rounded-lg shadow-md"
          >
            <transition enter-active-class="transform ease-out duration-300 transition"
                        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                        leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100"
                        leave-to-class="opacity-0">
              <div
                   class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
                <div class="p-4">
                  <div class="flex items-start">
                    <div class="flex-shrink-0">
                      <CheckCircleIcon v-if="notification.type === 'success'" class="h-10 w-10 text-green-400"
                                       aria-hidden="true"/>
                      <ExclamationCircleIcon v-if="notification.type === 'error'" class="h-10 w-10 text-warning"
                                             aria-hidden="true"/>
                    </div>
                    <div class="ml-3 w-0 flex-1 pt-0.5">
                      <p class="text-base font-medium text-gray-900">{{ notification.title }}</p>
                      <p class="mt-1 text-sm text-gray-500">{{ notification.text }}</p>
                    </div>
                    <div class="ml-4 flex-shrink-0 flex">
                      <button type="button" @click="show = false"
                              class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        <span class="sr-only">Close</span>
                        <XIcon class="h-5 w-5" aria-hidden="true"/>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </Notification>
      </div>
    </div>
  </NotificationGroup>
  <div class="space-y-10 divide-y divide-gray-900/10">

    <div class="grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3">
      <div class="px-4 sm:px-0">
        <h2 class="text-base font-semibold leading-7 text-gray-900">Profil</h2>
        <p class="mt-1 text-sm leading-6 text-gray-600">
          Ton identité provient de ton compte Google Workspace.
          L'exercice fiscal sélectionné détermine les données affichées dans toute la console.
        </p>
      </div>

      <form class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2" @submit.prevent="postNow">
        <div class="px-4 py-6 sm:p-8">
          <div class="flex items-center gap-x-4 pb-8">
            <span
                class="flex h-12 w-12 items-center justify-center rounded-full bg-indigo-600 text-lg font-semibold text-white">
              {{ initials }}
            </span>
            <div>
              <p class="text-sm font-semibold text-gray-900">{{ profileData.name }}</p>
              <p class="text-sm text-gray-500">{{ profileData.email }}</p>
            </div>
            <span
                class="ml-auto inline-flex items-center gap-x-1.5 rounded-full bg-green-50 px-2.5 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
              <CheckCircleIcon class="h-4 w-4"/>
              Connecté via Google
            </span>
          </div>

          <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div class="sm:col-span-4">
              <label for="name" class="block text-sm font-medium leading-6 text-gray-900">Nom complet</label>
              <div class="mt-2">
                <input
                    v-model="profileData.name"
                    type="text" name="name" id="name" autocomplete="name"
                    class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
              </div>
            </div>

            <div class="sm:col-span-4">
              <label for="email" class="block text-sm font-medium leading-6 text-gray-900">Adresse email</label>
              <div class="mt-2">
                <input
                    :value="profileData.email"
                    id="email" name="email" type="email" disabled
                    class="block w-full cursor-not-allowed rounded-md border-0 bg-gray-50 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-200 sm:text-sm sm:leading-6"/>
              </div>
              <p class="mt-1 text-xs text-gray-500">Gérée par Google Workspace — sert d'identifiant de connexion.</p>
            </div>

            <div class="sm:col-span-4">
              <label class="block text-sm font-medium leading-6 text-gray-900">Exercice fiscal</label>
              <div class="mt-2">
                <Multiselect v-if="fiscalYearData.length"
                             v-model="profileData.fiscal_year_id"
                             :options="fiscalYearData"
                             label="name"
                             valueProp="id"
                             :object="false"
                             :resolve-on-load="false"
                             :min-chars="1"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
          <button type="submit"
                  class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
            Enregistrer
          </button>
        </div>
      </form>
    </div>

    <div class="grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3">
      <div class="px-4 sm:px-0">
        <h2 class="text-base font-semibold leading-7 text-gray-900">Import des factures (Gmail)</h2>
        <p class="mt-1 text-sm leading-6 text-gray-600">
          Autorisation donnée à Clafoutis pour lire la boîte Gmail et importer automatiquement les factures
          fournisseurs. Indépendante de ta connexion à la console.
        </p>
      </div>

      <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
        <div class="px-4 py-6 sm:p-8">
          <div class="max-w-2xl">

            <div v-if="googleData.status === 1"
                 class="flex items-start gap-x-4 rounded-lg border border-green-200 bg-green-50 p-4">
              <CheckCircleIcon class="h-6 w-6 flex-shrink-0 text-green-500"/>
              <div>
                <h3 class="text-sm font-semibold text-green-800">Boîte Gmail connectée</h3>
                <p class="mt-1 text-sm text-green-700">
                  {{ googleData.user }}
                </p>
                <p class="mt-1 text-xs text-green-700/80">
                  Les factures reçues par email sont importées automatiquement toutes les 10 minutes.
                </p>
              </div>
            </div>

            <div v-else-if="googleData.status === 0"
                 class="flex items-start gap-x-4 rounded-lg border border-amber-200 bg-amber-50 p-4">
              <ExclamationCircleIcon class="h-6 w-6 flex-shrink-0 text-amber-500"/>
              <div>
                <h3 class="text-sm font-semibold text-amber-800">Boîte Gmail non connectée</h3>
                <p class="mt-1 text-sm text-amber-700">
                  L'import automatique des factures depuis Gmail est inactif tant que la boîte n'est pas reconnectée.
                </p>
                <a :href="googleData.url"
                   class="mt-3 inline-flex items-center rounded-md bg-amber-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-amber-500">
                  Connecter la boîte Gmail
                </a>
              </div>
            </div>

            <div v-else class="flex items-center gap-x-3 text-sm text-gray-500">
              <svg class="h-5 w-5 animate-spin text-gray-400" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"/>
              </svg>
              Vérification de la connexion Gmail…
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {CheckCircleIcon, ChevronRightIcon, MailIcon, ExclamationCircleIcon} from '@heroicons/vue/solid'
import {XIcon} from '@heroicons/vue/solid'
import {notify, Notification, NotificationGroup} from 'notiwind'

</script>

<script>
import Multiselect from '@vueform/multiselect'
import axios from "axios";
import {usePost} from "@/composables/fetch";

export default {
  data: () => ({
    notifications: "",
    endpoint: 'user',
    profileData: {
      fiscal_year_id: null,
      fiscal_year: {}
    },
    fiscalYearData: [],
    isLoaded: false,
    polling: null,
    googleData: {}
  }),
  computed: {
    initials() {
      const name = this.profileData.name || this.profileData.email || '';
      return name.split(/[\s.@]+/).filter(Boolean).slice(0, 2).map(part => part[0].toUpperCase()).join('');
    }
  },
  mounted() {
    this.fetchProfile()
    this.fetchFiscalYear()
    this.intervalFetchData();
    this.fetchGoogleConnexion();
  },
  beforeUnmount() {
    clearInterval(this.polling)
  },
  methods: {
    async postNow() {
      try {
        const token = await this.$auth.getAccessTokenSilently();
        await usePost(this.endpoint, this.profileData, token)
        await this.fetchProfile();
        notify({group: 'bottom', type: 'success', title: 'Profil enregistré', text: 'Tes modifications ont été prises en compte.'}, 3000)
      } catch (e) {
        notify({group: 'bottom', type: 'error', title: 'Erreur', text: 'Impossible d\'enregistrer le profil.'}, 4000)
      }
    },

    intervalFetchData: function () {
      this.polling = setInterval(() => {
        this.fetchProfile();
        this.fetchFiscalYear();
        this.fetchGoogleConnexion();
      }, 10000);
    },
    formatDate(dateString) {
      const date = new Date(dateString);

      return new Intl.DateTimeFormat('en-GB').format(date);
    },

    async fetchFiscalYear() {
      const token = await this.$auth.getAccessTokenSilently();
      const HTTP = axios.create({
        baseURL: `https://billing.clafoutis.eu/api`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      HTTP.get('fiscalyear')
          .then(response => {
            this.fiscalYearData = response.data
            this.isLoaded = true;
          })
          .catch(e => {
            console.log(e)
          })
    },

    async fetchGoogleConnexion() {
      const token = await this.$auth.getAccessTokenSilently();
      const HTTP = axios.create({
        baseURL: `https://billing.clafoutis.eu/api`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      HTTP.get(this.endpoint + '/google')
          .then(response => {
            this.googleData = response.data
            this.isLoaded = true;
          })
          .catch(e => {
            console.log(e)
          })
    },

    async fetchProfile() {
      const token = await this.$auth.getAccessTokenSilently();
      const HTTP = axios.create({
        baseURL: `https://billing.clafoutis.eu/api`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      HTTP.get(this.endpoint)
          .then(response => {
            this.profileData = response.data
            this.isLoaded = true;
          })
          .catch(e => {
            console.log(e)
          })
    },
  }
}

</script>
